import { useAuth } from "#/feature/auth/auth-context";
import { Globe, Library, ListChecks, Search, User } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { css, cx } from "styled-system/css";
import {
  bottomBarContainerStyles,
  bottomBarInnerStyles,
  bottomBarItemStyles,
  contentMaxWidth,
} from "#/capacitor-app.css";

const bottomNavInnerMaxStyles = css({
  maxWidth: contentMaxWidth,
  marginInline: "auto",
});

function useNavItems() {
  const { user, isAuthenticated } = useAuth();

  const navItems = [
    { icon: Library, name: "Library", path: "/" },
    { icon: Search, name: "Search", path: "/search", adminOnly: true },
    { icon: Globe, name: "Sources", path: "/sources" },
    { icon: ListChecks, name: "Jobs", path: "/jobs", adminOnly: true },
    { icon: User, name: "User", path: "/user" },
  ].filter((item) => {
    if (!isAuthenticated) {
      return false;
    }
    if (item.adminOnly && user?.role !== "admin") {
      return false;
    }
    return true;
  });

  return { navItems, isAuthenticated };
}

export function Navbar() {
  const location = useLocation();
  const { navItems, isAuthenticated } = useNavItems();
  if (!isAuthenticated) {
    return null;
  }
  const isPathActive = (path: string) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };
  return (
    <nav className={bottomBarContainerStyles}>
      <div className={cx(bottomNavInnerMaxStyles, bottomBarInnerStyles)}>
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={bottomBarItemStyles({ active: isPathActive(item.path) })}
            title={item.name}
          >
            <item.icon size={24} />
          </Link>
        ))}
      </div>
    </nav>
  );
}
